import HomeContentBox from './HomeContentBox';

export default class HomeContentBoxModal extends HomeContentBox {
    renderContent = () => (
        <div className="content" dangerouslySetInnerHTML={{__html: this.props.box.content}}></div>
    )

    canShowReadMore() {
        return this.props.box.readMoreLink;
    }

    onClickReadMore() {
        window.open(this.props.box.readMoreLink);
    }

    renderTitle = () => (
        <span className="title title-modal">
            <div>{this.props.box.title}</div>
            <div className="close" onClick={() => this.props.onCloseClick()}>x</div>
        </span>
    )
}